import { ref, computed } from 'vue'

const KEY = 'OPERA.consent.v1'
const consent = ref(read())
const visible = computed(() => consent.value === null)

function read() {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'accept' || v === 'reject' || v === 'custom' ? v : null
  } catch {
    return null
  }
}

function write(v) {
  try { localStorage.setItem(KEY, v) } catch { /* noop */ }
}

/** Consent gate — no telemetry or ads are loaded until the user decides. */
export function useConsent() {
  function accept() { consent.value = 'accept'; write('accept') }
  function reject() { consent.value = 'reject'; write('reject') }
  function custom() { consent.value = 'custom'; write('custom') }

  return {
    consent,
    visible,
    accept,
    reject,
    custom,
    telemetryAllowed: computed(() => consent.value === 'accept' || consent.value === 'custom'),
    adsAllowed: computed(() => consent.value === 'accept' || consent.value === 'custom')
  }
}
